import { getWindowObject } from './get-window-object';
/**
 * Safely checks if the window exists and supports eventListeners
 */
export const HAS_WINDOW_LISTENERS = !!getWindowObject('addEventListener');
